import type { ReactNode } from "react";
import { Box, type SxProps, type Theme } from "@mui/material";
import { useIsMobile } from "../../hooks/useIsMobile";
import { MOBILE_BREAKPOINT } from "../../styles/responsive";
import { listCompactSx } from "../../styles/sx/compact";

interface Props {
  children: ReactNode;
  /** SP 時の文字サイズ縮小。デフォルトは一覧向け。情報量が多い画面は detail を渡す */
  compactSx?: SxProps<Theme>;
}

type SxItem = Exclude<SxProps<Theme>, readonly unknown[]>;

const toSxArray = (sx: SxProps<Theme>): readonly SxItem[] =>
  Array.isArray(sx) ? (sx as readonly SxItem[]) : [sx as SxItem];

/** 画面ルート用の器。SP は余白を詰め、文字サイズ縮小を自動適用する。 */
export const PageContainer: React.FC<Props> = ({
  children,
  compactSx = listCompactSx,
}) => {
  const isMobile = useIsMobile();
  return (
    <Box
      sx={[
        { p: { xs: 2, [MOBILE_BREAKPOINT]: 3 }, minWidth: 0 },
        // sx は関数・配列も取り得るため、MUI 推奨の配列合成でそのまま渡す
        ...(isMobile ? toSxArray(compactSx) : []),
      ]}
    >
      {children}
    </Box>
  );
};
